import { SITE_URL } from "@/config/site";
import { SEGMENTS } from "@/pages/siteContent";

const OG = "https://images.unsplash.com/photo-1705579605238-24a90c8799c5?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200";

export const SEO = {
  "/": {
    title: "Pompe à chaleur collective financée par les CEE | Airthermo",
    description: "Remplacez votre chaudière collective gaz ou fioul par une pompe à chaleur. 0 € de frais de courtage, jusqu'à 100 % financé par les CEE, jusqu'à 50 % d'économies. Étude gratuite.",
    image: OG,
  },
  "/le-cabinet": {
    title: "Le cabinet Airthermo, courtier CEE en pompe à chaleur | Airthermo",
    description: "Airthermo, cabinet de courtage CEE : nous finançons votre pompe à chaleur collective et coordonnons le projet avec un installateur RGE. 0 € de frais de courtage. Étude gratuite.",
    image: "https://images.unsplash.com/photo-1681949103006-70066fb25dfe?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  },
  "/mentions-legales": {
    title: "Mentions légales | Airthermo",
    description: "Mentions légales du site airthermo.fr : éditeur, hébergeur et propriété intellectuelle d'Airthermo, cabinet de courtage en énergie à Rennes.",
    image: OG,
  },
  "/politique-de-confidentialite": {
    title: "Politique de confidentialité | Airthermo",
    description: "Comment Airthermo collecte, utilise et protège vos données personnelles, et comment exercer vos droits d'accès, de rectification et de suppression (RGPD).",
    image: OG,
  },
  ...Object.fromEntries(SEGMENTS.map((s) => [`/pompe-a-chaleur/${s.slug}`, { title: s.seoTitle, description: s.seoDescription, image: s.image.replace("w=1400", "w=1200") }])),
};

export const PUBLIC_ROUTES = Object.keys(SEO);
export const seoFor = (path) => SEO[path] || SEO["/"];
export const absoluteUrl = (path) => `${SITE_URL}${path === "/" ? "/" : path}`;
